import React from 'react'
import './ShortWhyWeareBest.css';
import expertise from '../../assets/images/expertise1.png';
import innovation from '../../assets/images/innovation1.png';
import satisfaction from '../../assets/images/satisfaction1.png';
import fastdelivery from '../../assets/images/fastdelivery1.png';
export default function ShortWhyWeareBest() {
  return (
    <>
     <section className="why-choose-us">
      <div className="container">
        <h2>Why Choose Us?</h2>
        <p>
          We offer unmatched expertise, innovative solutions, and a commitment
          to delivering exceptional results.
        </p>

        <div className="features">
          <div className="feature-item">
            <img
              src={expertise} // Replace with your expertise icon/image
              alt="Expertise"
              className="feature-icon"
            />
            <h3>Expertise</h3>
            <p>Our team brings years of specialized experience to every project.</p>
          </div>

          <div className="feature-item">
            <img
              src={innovation} // Replace with your innovation icon/image
              alt="Innovation"
              className="feature-icon"
            />
            <h3>Innovation</h3>
            <p>We use cutting-edge technology to drive growth and success.</p>
          </div>

          <div className="feature-item">
            <img
              src={satisfaction} // Replace with your customer satisfaction icon/image
              alt="Customer Satisfaction"
              className="feature-icon"
            />
            <h3>Customer Satisfaction</h3>
            <p>We are committed to exceeding client expectations with every project.</p>
          </div>

          <div className="feature-item">
            <img
              src={fastdelivery} // Replace with your fast delivery icon/image
              alt="Fast Delivery"
              className="feature-icon"
            />
            <h3>Fast Delivery</h3>
            <p>We ensure timely project completion without compromising quality.</p>
          </div>
        </div>

        <button className="cta-button">Get In Touch</button>
      </div>
    </section>
    
    
    
    
    </>
  )
}
